import { Injectable, signal } from '@angular/core';

/**
 * Serviço responsável por controlar configurações de layout da aplicação
 */

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  readonly usarPaddingPadrao = signal(true);

  definirPaddingPadrao(usar: boolean): void {
    this.usarPaddingPadrao.set(usar);
  }

  resetarConfiguracoes(): void {
    this.usarPaddingPadrao.set(true);
  }
}
